import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class SiteActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Web/Site/SiteBrowser")
	}

	render() {
		return (
			<Activity 
				name="Site"
				RenderedComponent={this.RenderedComponent}
				context="Site"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(SiteActivity)
